import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type { Setting } from '../domain/setting';

export const useSettingStore = defineStore('settings', () => {
  const defaultSetting: Setting = {
    sharedClient: {
      storageArea: {
        nameFormat: '',
        displayTextFormula: '',
        placeDisplayTextFormula: '',
        logYardLength: 0,
        logYardWidth: 0,
        logYardSideArea: 0,
      },
      map: {
        bearing: 0,
        pitch: 0,
        zoom: 4,
        latitude: 54.5,
        longitude: 15.0,
        minZoom: 3,
      },
    },
  };
  const setting = ref(defaultSetting);
  const mapSettings = computed(() => setting.value.sharedClient.map);

  return {
    setting,
    mapSettings,
  };
});
